class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById("ProductGridContainer").innerHTML = new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("ProductGridContainer").innerHTML;

    document
      .getElementById("ProductGridContainer")
      .querySelectorAll(".scroll-trigger")
      .forEach((element) => {
        element.classList.add("scroll-trigger--cancel");
      });

    setTimeout(() => {

      if (window.ajaxinateInstance) {
        window.ajaxinateInstance.destroy();
      }

      window.ajaxinateInstance = new Ajaxinate({
        container: "#product-grid",
        pagination: "#AjaxinatePagination",
        method: document.body.classList.contains("infinite-scroll") ? "scroll" : "click",
        offset: 300,
      });

      if (typeof window.initializeCollectionSwipers === 'function') {
        window.initializeCollectionSwipers();
      }

    }, 200);
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

document.addEventListener('click', function(event) {
  if (event.target.closest('.round')) {
    var filterSection = event.target.closest('.filter_section');
    var inputElement = filterSection.querySelector('.mobile-facets__item[filter-type="in-stock"] input');
    
    // Trigger click on the input element inside .filter_section
    inputElement.click();

    // Toggle 'active-toggle' class on the closest .switch parent element
    var switchElement = event.target.closest('.switch');
    switchElement.classList.toggle('active-toggle');
  }
});

// Handle click event on elements with the class 'active-availability'
document.addEventListener('click', function(event) {
  if (event.target.closest('.active-availability')) {
    var switchElements = document.querySelectorAll('.switch');
    switchElements.forEach(function(switchElement) {
      switchElement.classList.remove('active-toggle');
    });
  }
});

// Check if the input is checked and toggle the 'active-toggle' class accordingly
var inputElement = document.querySelector('.filter_section .mobile-facets__item[filter-type="in-stock"] input');
if (inputElement && inputElement.checked) {
  // console.log('checkInput::' + inputElement.checked);
  var switchElements = document.querySelectorAll('.switch');
  switchElements.forEach(function(switchElement) {
    switchElement.classList.remove('active-toggle');
  });
} else {
  var switchElements = document.querySelectorAll('.switch');
  switchElements.forEach(function(switchElement) {
    switchElement.classList.add('active-toggle');
  });
  // console.log('not checked checkInput');
}

document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("product-grid");
  const iconGrid = document.querySelector(".cdk_grid_layout .icon-grid");
  const iconSquare = document.querySelector(".cdk_grid_layout .icon-square");

  // Get the stored class from sessionStorage
  const productGridClass = sessionStorage.getItem("productGridClass");

  // Apply the stored class if it exists
  if (productGridClass) {
      productGrid.classList.remove("grid-one-in-row", "grid-two-in-row");
      productGrid.classList.add(productGridClass);

      if (productGridClass === "grid-two-in-row") {
          iconGrid.classList.add("active");
          iconSquare.classList.remove("active");
      } else {
          iconSquare.classList.add("active");
          iconGrid.classList.remove("active");
      }
  }

  // Click event to apply two-in-row grid layout
  iconGrid.addEventListener("click", function () {
      productGrid.classList.add("grid-two-in-row");
      productGrid.classList.remove("grid-one-in-row");

      sessionStorage.setItem("productGridClass", "grid-two-in-row");

      iconGrid.classList.add("active");
      iconSquare.classList.remove("active");
  });

  // Click event to apply one-in-row grid layout
  iconSquare.addEventListener("click", function () {
      productGrid.classList.add("grid-one-in-row");
      productGrid.classList.remove("grid-two-in-row");

      sessionStorage.setItem("productGridClass", "grid-one-in-row");

      iconSquare.classList.add("active");
      iconGrid.classList.remove("active");
  });
  document.addEventListener('click', function (event) {
    const clearBtn = event.target.closest('.mobile-facets__arrow');
    if (!clearBtn) return;
  
    event.preventDefault();
  
    // Get the current filter block (Size only)
    const filterBlock = clearBtn.closest('.js-filter');
    if (!filterBlock) return;
  
    // Uncheck only checkboxes inside this filter
    const inputs = filterBlock.querySelectorAll('input[type="checkbox"], input[type="radio"]');
    inputs.forEach(input => {
      input.checked = false;
    });
  
    // Re-submit the facet form to refresh products
    const form = filterBlock.closest('form');
    if (form) {
      const eventObj = new Event('input', { bubbles: true });
      form.dispatchEvent(eventObj);
    }
  });
  
});
////////////// Custom Sort By feature PLP  //////////////

// document.addEventListener("DOMContentLoaded", function() {
//   document.addEventListener("click", function(event) {
//       const customFacetName = event.target.closest(".sort-list");

//       if (customFacetName) {
//           const facetChange = customFacetName.getAttribute("value");
          
//           // Select the option in the dropdown that matches the facetChange value
//           const selectOption = document.querySelector(".cdksortby select option[value='" + facetChange + "']");
//           if (selectOption) {
//               selectOption.selected = true; // Mark the option as selected
//           }
          
//           // Trigger change event on the select element
//           const facetFiltersSort = document.querySelector(".facet-filters__sort");
//           if (facetFiltersSort) {
//               facetFiltersSort.value = facetChange; 
//               const event = new Event('change', { bubbles: true });
//               facetFiltersSort.dispatchEvent(event); // Trigger the change event
//           }
          
//           // Manage active class on custom facets
//           const customFacets = document.querySelectorAll(".sort-list");
//           customFacets.forEach(facet => {
//               facet.classList.remove("selected"); // Remove active class from all facets
//           });
//           customFacetName.classList.add("selected"); // Add active class to the clicked facet

//           // Show loading overlay
//           // const loadingOverlay = document.querySelector(".collection .loading-overlay");
//           // if (loadingOverlay) {
//           //     loadingOverlay.style.display = "block"; // Show loading overlay
//           // }
//       }
//   });
// });


// document.addEventListener('DOMContentLoaded', function() {
//   // Change event for the facet filters sort
//   document.addEventListener('change', function(event) {
//       const facetFiltersSort = event.target.closest('.facet-filters__sort');
      
//       if (facetFiltersSort) {
//           const sortBy = facetFiltersSort.value;
//           const pageURL = window.location.href;
//           let newUrl = '';

//           // Find the index of "sort_by="
//           const startIndex = pageURL.indexOf("sort_by=");
          
//           if (startIndex !== -1) {
//               // Extract the text after "sort_by="
//               const textAfterSortBy = pageURL.substring(startIndex + "sort_by=".length);
//               // Remove the extracted text from the URL
//               const modifiedURL = pageURL.replace(textAfterSortBy, '');
//               newUrl = modifiedURL + sortBy + '&';
//               console.log("Modified URL: " + modifiedURL);
//           } else if (pageURL.indexOf("search") > -1) { 
//               newUrl = pageURL + '&sort_by=' + sortBy + '&';
//           } else {
//               newUrl = pageURL + '?sort_by=' + sortBy + '&';
//           }

//           console.log('newUrl::' + newUrl);

//           // Perform a fetch request to fetch the sorted products
//           fetch(newUrl, {
//               method: 'GET',
//               headers: {
//                   'Content-Type': 'application/json'
//               }
//           })
//           .then(response => response.text())
//           .then(data => {
//               // Update the history state
//               history.pushState('data', '', newUrl);

//               // Create a DOM parser to extract product listings
//               const parser = new DOMParser();
//               const doc = parser.parseFromString(data, 'text/html');
//               const productListing = doc.querySelectorAll('#product-grid .collection__item');

//               // Update product grid
//               const productGrid = document.querySelector('#product-grid:not(.template-search__results)');
//               if (productGrid) {
//                   productGrid.innerHTML = '';
//                   productListing.forEach(item => productGrid.appendChild(item.cloneNode(true)));
//               }

//               const searchResultsGrid = document.querySelector('#product-grid.template-search__results .product-grid');
//               if (searchResultsGrid) {
//                   searchResultsGrid.innerHTML = '';
//                   productListing.forEach(item => searchResultsGrid.appendChild(item.cloneNode(true)));
//               }

//               // Hide the loading overlay
//               // const loadingOverlay = document.querySelector(".collection .loading-overlay");
//               // if (loadingOverlay) {
//               //     loadingOverlay.style.display = 'none';
//               // }
//           })
//           .catch(error => {
//               console.error('Error fetching sorted products:', error);
//           });
//       }
//   });
// });
